"use strict";
import "./components/config";
import "./components/header";
import "./components/lazy";
import "./components/sliders";
import "./components/dropdown";
import "./components/tabs";
import "./components/modal";
import "./components/popup-video";
import "./components/animations";
import "./components/sliders";
import "./components/login-form";
import "./components/stikey";
import "./components/costing-tool";
import "./components/quote-download";
